export default {
  close: {
    id: 'product_seller_details_modal_close',
    defaultMessage: 'Close',
  },
  title: {
    id: 'product_seller_details_modal_title',
    defaultMessage: 'EU certification',
  },
  section1Title: {
    id: 'product_seller_details_modal_section1_title',
    defaultMessage: 'Manufacturer',
  },
  section1Item2: {
    id: 'product_seller_details_modal_section1_item2',
    defaultMessage: 'Brand',
  },
  section1Item3: {
    id: 'product_seller_details_modal_section1_item3',
    defaultMessage: 'Contact',
  },
  section1Item4: {
    id: 'product_seller_details_modal_section1_item4',
    defaultMessage: 'Address',
  },
  section2Title: {
    id: 'product_seller_details_modal_section2_title',
    defaultMessage: 'Responsible operator in the EU',
  },
  section2Item2: {
    id: 'product_seller_details_modal_section2_item2',
    defaultMessage: 'Contact',
  },
  section2Item3: {
    id: 'product_seller_details_modal_section2_item3',
    defaultMessage: 'Address',
  },
  section3Title: {
    id: 'product_seller_details_modal_section3_title',
    defaultMessage: 'Seller certification',
  },
  section3Item1Title: {
    id: 'product_seller_details_modal_section3_item1_title',
    defaultMessage: 'European standards compliant',
  },
  section3Item1Text: {
    id: 'product_seller_details_modal_section3_item1_text',
    defaultMessage:
      'The Seller acknowledges compliance with EU safety requirements and Back Market quality charter.',
  },
  section3Item2Title: {
    id: 'product_seller_details_modal_section3_item2_title',
    defaultMessage: 'Lifespan on Back Market:',
  },
  section3Item2Date: {
    id: 'product_seller_details_modal_section3_item2_date',
    defaultMessage: `{years, plural,
      one {# year}
      other {# years}
    } {months, plural,
      one {# month}
      other {# months}
    }`,
  },
  section3Button: {
    id: 'product_seller_details_modal_section3_item2_button',
    defaultMessage: 'View seller page',
  },
}
